export const columnConverter = (headers) =>
  headers.map((header) => ({
    ...header,
    cell: (info) => info.getValue(),
  }));

export default columnConverter;
